import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { getCsrfTokenFromCookie } from '@/infrastructure/api/utils/csrf'

export function applyAuthInterceptor(instance: AxiosInstance): void {
  instance.interceptors.request.use((config: InternalAxiosRequestConfig) => {
    if (['post', 'put', 'delete', 'patch'].includes(config.method?.toLowerCase() ?? '')) {
      const csrfToken = getCsrfTokenFromCookie()
      if (csrfToken) {
        config.headers['X-XSRF-TOKEN'] = csrfToken
      }
    }
    return config
  })
}
